import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const AiEngineTab = lazy(() => import('@/components/organisms/AiEngineTab'))

export const Route = createFileRoute('/_authenticated/admin/ai-engine')({
  component: () => (
    <Suspense fallback={<div className="flex justify-center py-12"><div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" /></div>}>
      <AiEngineTab />
    </Suspense>
  ),
})
